import { useCallback } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Prop = {
	minRoomNum: ForNodeType<number>;
	maxRoomNum: ForNodeType<InputMaybe<number> | undefined> | undefined;

	onSetViewModel: (
		values: {
			key: "minRoomNum" | "maxRoomNum";
			value: ForNodeType<InputMaybe<number> | undefined> | undefined;
		}[],
	) => void;
};

export const useMinAndMaxRoomNum = ({ maxRoomNum, minRoomNum, onSetViewModel }: Prop) => {
	const onSetMinRoomNum = useCallback(
		(input: number | null | undefined) => {
			onSetViewModel([
				{
					key: "minRoomNum",
					value: {
						...minRoomNum,
						isEdited: minRoomNum.isEdited,
						value: input ?? 0,
					},
				},
			]);
		},
		[minRoomNum, onSetViewModel],
	);

	const onSetMaxRoomNum = useCallback(
		(input: number | null | undefined) => {
			onSetViewModel([
				{
					key: "maxRoomNum",
					value: {
						...maxRoomNum,
						isEdited: maxRoomNum?.isEdited ?? false,
						value: input,
					},
				},
			]);
		},
		[maxRoomNum, onSetViewModel],
	);

	return {
		minRoomNum,
		maxRoomNum,
		onSetMinRoomNum,
		onSetMaxRoomNum,
	};
};
